/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createFieldHook } from '../../core/factories/createFieldHook.js';
import { createListHook } from '../../core/factories/createListHook.js';
import { createPrefetchHook } from '../../core/factories/createPrefetchHook.js';
import type { GetProposalsRow } from '../openapi-types.gen.js';
import type { PagedData } from '../../types/PagedData.js';
import { type useGetProposalsArgs, useGetProposalsSpec, useGetProposalsRealtime, useGetProposalsPagination } from '../specs/proposals.spec.gen.js';
import type { PaginationContract } from '../../core/factories/createListHook.js';

export type { GetProposalsRow } from '../openapi-types.gen.js';
export type { useGetProposalsArgs } from '../specs/proposals.spec.gen.js';

// Codegen-typed pagination contract is narrower than the runtime
// PaginationContract signature (which takes unknown args). The cast erases
// the call-site narrowness — the runtime fetcher itself remains typed.
const _useGetProposalsPaginationContract = useGetProposalsPagination as unknown as PaginationContract;

/**
 * Manual pagination: returns `fetchNextPage` / `hasNextPage` /
 * `isFetchingNextPage` so the caller wires a "Load more" button or
 * pagination control. Same cache entry as `useGetProposalsInfinite` — both
 * read/write the same `PagedData<GetProposalsRow>` blob.
 *
 * @remarks Available query params (forwarded automatically; pass
 * via the hook's args): marketType, status, excludeStatus, category, location, search, creator, pubkeys, fundingMin, fundingMax, stakedMin, stakedMax, backersMin, backersMax, outcomesMin, outcomesMax, createdAfter, createdBefore, sortBy, sortOrder, limit, cursor.
 */
export const useGetProposals = createListHook({
  spec: useGetProposalsSpec,
  realtime: useGetProposalsRealtime,
  entityKey: 'market',
  pagination: _useGetProposalsPaginationContract,
});


/**
 * Auto-infinite: same cache as `useGetProposals`, but the last-row viewport
 * sentinel auto-fires `fetchNextPage` so the consumer never has to wire
 * it. Use for scroll-driven feeds; use `useGetProposals` for "Load more"
 * buttons / non-scroll UX.
 */
export const useGetProposalsInfinite = createListHook({
  spec: useGetProposalsSpec,
  realtime: useGetProposalsRealtime,
  entityKey: 'market',
  pagination: _useGetProposalsPaginationContract,
  autoLoadMore: true,
});


/**
 * Per-field subscription hook for the `useGetProposals` cache entry. Call inside
 * an `<Items>` render tree (typically from a leaf component). Returns the
 * named field's value for the given row id; only the call site re-renders
 * when that field changes. Uses TanStack's canonical "per-component select"
 * pattern internally.
 *
 *     function Volume({ pubkey }) {
 *       const value = useGetProposalsField(pubkey, 'volume24h');
 *       return <span>{value}</span>;
 *     }
 */
export const useGetProposalsField = createFieldHook<GetProposalsRow>('useGetProposalsField');

/**
 * Hover/intent prefetch companion for `useGetProposals` (also covers
 * `useGetProposalsInfinite` — same cache entry). Returns a stable
 * `(args) => Promise<void>` callback that fires the real HTTP request
 * for page 1 and writes the response into the cache. The component owning
 * the callback does NOT subscribe — no re-renders on data, no NATS
 * subscription. Idempotent: TanStack `prefetchQuery` is a no-op when a
 * fresh cache entry already exists.
 *
 *     function NavLink() {
 *       const prefetch = usePrefetchGetProposals();
 *       return (
 *         <a
 *           onMouseEnter={() => prefetch({})}
 *           onFocus={() => prefetch({})}
 *         >Markets</a>
 *       );
 *     }
 */
export const usePrefetchGetProposals = createPrefetchHook(useGetProposalsSpec);
